import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import UpgradeModal from './ui/UpgradeModal'

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-bg)' }}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />

      {/* Main area shifts with sidebar */}
      <div
        className="flex flex-col min-h-screen transition-all duration-300"
        style={{ marginLeft: collapsed ? '72px' : '240px' }}
      >
        <Header sidebarCollapsed={collapsed} />

        <main className="flex-1 p-6 mt-16">
          <Outlet />
        </main>
      </div>

      {/* Global upgrade modal */}
      <UpgradeModal />
    </div>
  )
}
